t = require('views/internal/teacup-with-helpers')('header_two_factor_backups_banner')

module.exports = ->
  t.p '.u-bottom', ->
    t.format 'generate-new-backup-codes'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_two_factor_backups_banner.coffee